module.exports = __webpack_public_path__ + "img/phone_bill_navbar_bg.59d1d28b.png";